import { render, staticRenderFns } from "./ChildButtonLabelEditor.vue?vue&type=template&id=35001268&scoped=true&"
import script from "./ChildButtonLabelEditor.vue?vue&type=script&lang=js&"
export * from "./ChildButtonLabelEditor.vue?vue&type=script&lang=js&"
import style0 from "./ChildButtonLabelEditor.vue?vue&type=style&index=0&id=35001268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35001268",
  null
  
)

export default component.exports